import { Box, Modal } from '@pinchenterprisesnpm/friday-ui'
import { InfoBanner } from '@src/features/shift-post-v2/components/info-banner'
import { SectionItemText } from '@src/features/shift-post-v2/steps/screening-requirements-step/components/screening-section/screening-section.styles'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'
import { ShiftBadges } from '@src/features/shift-post-v2/steps/screening-requirements-step/components/screening-section/components'
import { ShiftPostPage } from '@src/features/shift-post-v2/pages'
import { ScrollableModalContent } from '@src/ui/components/common/style'

const { Header, Content } = Modal

interface IEditScreeningModalProps {
  isOpen: boolean
  closeModal: () => void
  sourcePage?: ShiftPostPage
}

export const EditScreeningModal = ({
  isOpen,
  closeModal,
  sourcePage,
}: IEditScreeningModalProps) => {
  const infoBannerMessages =
    'Contact your Account Manager to get additional screening requirements enabled for your account.'
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} height='600px' width='700px'>
      <Header title='Edit Screening Requirements' />
      <ScrollableModalContent>
        <Box px='sm'>
          <SectionItemText>
            Only allow Upshifters with the selected screening requirements to book this shift.
          </SectionItemText>
        </Box>

        <InfoBanner description={infoBannerMessages} icon={faInfoCircle} />
        <ShiftBadges sourcePage={sourcePage} />
      </ScrollableModalContent>
    </Modal>
  )
}
